<!--
 * @Description: 客户账号详情
 * @Author: cxh
 * @Date: 2022-05-24 15:19:34
 * @LastEditTime: 2023-03-14 09:12:54
 * @LastEditors: cxh
-->
<template>
  <dc-layout-main :is-breadcrumb="true">
    <dc-layout-content>
      <CosViewContent>
        <a-tabs>
          <a-tab-pane key="1" :tab="t('common.baseTabs')">
            <baseMessage :id="route.query.id" returnName="DcCosOFbuAccountCode" />
          </a-tab-pane>
          <a-tab-pane key="2" :tab="t('common.bussiessTabs')">
            <tabsBusiness
              returnName="DcCosOFbuAccountCode"
              :arkCodeId="route.query.id"
              :permissionPage="permissionBuss"
            />
          </a-tab-pane>
          <a-tab-pane key="3" :tab="t('common.contractTabs')">
            <tabsContract returnName="DcCosOFbuAccountCode" />
          </a-tab-pane>
          <a-tab-pane key="4" :tab="t('common.conversionTabs')">
            <TabsConversion :resourceId="route.query.id" appId="cos_ofbu" />
          </a-tab-pane>
          <a-tab-pane key="5" :tab="t('common.operationLogTabs')">
            <TabsOperationLog appId="cos_ofbu" tableId="DcCosOFbuAccountCodeOperationLog" :resourceId="route.query.id" />
          </a-tab-pane>
        </a-tabs>
      </CosViewContent>
      <cos-footer-button :disabled="true" :hideOk="true" />
    </dc-layout-content>
  </dc-layout-main>
</template>
<script lang="ts">
import baseMessage from './components/baseMessage.vue'
import TabsOperationLog from '@/components/TabsOperationLog/index.vue'
import TabsConversion from '@/components/TabsConversion'
import tabsContract from '@/views/overseasSales/customerCenter/components/tabsContract.vue'
import tabsBusiness from '@/views/overseasSales/customerCenter/components/tabsBusiness.vue'
import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'
</script>
<script setup lang="ts">
const { t } = useI18n()
const route = useRoute()
const permissionBuss = {
  add: 'ofbu_arkcode_buss_add_btn',
  edit: 'ofbu_arkcode_buss_edit_btn',
  del: 'ofbu_arkcode_buss_del_btn'
}
</script>
